module.exports = __webpack_public_path__ + "icon-document.svg?37f450062d2b0388ddee54ed6eb17722";